import { render, staticRenderFns } from "./StudentExperience.vue?vue&type=template&id=3feb44b3&"
import script from "./StudentExperience.vue?vue&type=script&lang=js&"
export * from "./StudentExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports